var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 510") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inbox-show-details",
    transform: "translate(-922.000000, -585.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(653.000000, 581.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-510",
    transform: "translate(269.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,7.5 L5.3125,7.5 C5.14,7.5 5,7.36 5,7.1875 C5,7.015 5.14,6.875 5.3125,6.875 L11.25,6.875 C11.4225,6.875 11.5625,7.015 11.5625,7.1875 C11.5625,7.36 11.4225,7.5 11.25,7.5 M11.25,9.375 L5.3125,9.375 C5.14,9.375 5,9.235 5,9.0625 C5,8.89 5.14,8.75 5.3125,8.75 L11.25,8.75 C11.4225,8.75 11.5625,8.89 11.5625,9.0625 C11.5625,9.235 11.4225,9.375 11.25,9.375 M5.3125,5 L9.375,5 C9.5475,5 9.6875,5.14 9.6875,5.3125 C9.6875,5.485 9.5475,5.625 9.375,5.625 L5.3125,5.625 C5.14,5.625 5,5.485 5,5.3125 C5,5.14 5.14,5 5.3125,5 M8.123125,0.564375 C3.9875,0.564375 0.623125,3.335625 0.623125,6.74125 C0.623125,8.349375 1.35875,9.856875 2.70125,11.010625 L1.195,14.018125 C1.061875,14.283125 1.3425,14.56625 1.60625,14.440625 L5.629375,12.56875 C6.428125,12.8 7.26625,12.9175 8.123125,12.9175 C12.258125,12.9175 15.623125,10.146875 15.623125,6.74125 C15.623125,3.335625 12.258125,0.564375 8.123125,0.564375",
    id: "Fill-3388"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sms_icon.42e3290ddec9aca7a2bbbc9d19c1ba78.svg";